import $ from 'jquery';

( () => {

	let navigation = {

		isTouch: () => (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)),

		bootstrap: () => {

			navigation.initResponsive();
			navigation.initToggle();
			navigation.initSubMenus();

		},

		initResponsive: () => {

			navigation.checkResponsive();
			$(window).on( 'resize', navigation.checkResponsive );

		},

		checkResponsive: () => {

			// Transitions deaktivieren und Navigation ausblenden, damit man den Check nicht sieht
			$("html").addClass("no-transitions");
			$("header #main_menu").css("opacity", 0);

			// Navigation zurücksetzen
			navigation.reset();

			// Bei allen aus der ersten Ebene überprüfen, ob sie noch genug Platz haben
			let $navItems = $("header #main_menu > ul > li");

			let top = $navItems.eq(0).offset().top;

			$navItems.each( function() {

				if( top !== $(this).offset().top ) {
					$("html").removeClass("has-nav-desktop");
				}

			} );

			// Transitions aktivieren und Navigation wieder einblenden
			$("header #main_menu").css("opacity", 1);
			$("html").removeClass("no-transitions");


		},

		reset: () => {
			$("html").addClass("has-nav-desktop");
			$("html").removeClass("has-nav-toggled");
			$("#main_menu .menu-item-has-children").removeClass("has-submenu-opened");
		},

		initToggle: () => {

			$(".navigation__toggle").on( 'click', () => {

				$("html").toggleClass("has-nav-toggled");

			} );

		},

		initSubMenus: () => {

			// Touch-Device
			$("#main_menu .menu-item-has-children").on( 'click', function() {

				// Mouseover, Mouseout soll nur bei Geräten ohne Touch funktionieren
				if( ! navigation.isTouch() ) {
					return;
				}

				$(this).toggleClass( "has-submenu-opened" );


			});

			// Desktop
			$("#main_menu .menu-item-has-children").on( 'mouseleave mouseenter', function() {

				console.log("event");

				if( navigation.isTouch() ) {
					return;
				}

				$(this).toggleClass( "has-submenu-opened" );

			});

		}


	};

	$(document).ready( navigation.bootstrap );

})()